/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Plus d'infos",
  "CookieMessage.old.text":
    "Nous utilisons des cookies afin de faire fonctionner notre Webshop correctement. Afficher notre politique de cookies.",
  "CookieMessage.link": "L'acceptation des cookies",
  "CookieMessage.more_information": "En savoir plus sur les cookies Kramp",
  "CookieMessage.return": "Retour",
  "CookieMessage.intro.body":
    "Ces cookies sont déposés par nous-mêmes et par des tiers. Bien entendu, nous veillons à protéger votre vie privée. En cliquant sur Accepter les cookies ci-dessous, vous donnez votre accord à l’utilisation de ces cookies. En acceptant les cookies, vous bénéficierez pleinement des fonctionnalités de ce site web. Par exemple:",
  "CookieMessage.intro.list.1":
    "Ouverture de session automatique dans Mon compte",
  "CookieMessage.intro.list.2":
    "Analyse du comportement de navigation à des fins d’amélioration de ce site web.",
  "CookieMessage.intro.list.3":
    "Création d’un profil client nous permettant de vouas proposer des offres promotionnelles et des publicités personnalisées",
  "CookieMessage.intro.extra":
    'Vous ne souhaitez pas accepter tous les cookies? Vous pouvez effectuer par vous-même les modifications nécessaires dans les <a>paramètres</a>. Pour de plus amples informations, veuillez vous reporter à notre <a href="{legalLink}">Déclaration sur le respect de la vie privée et les cookies</a>.',
  "CookieMessage.intro.title": "Kramp utilise des cookies",
  "CookieMessage.settings.body":
    "Vous avez le choix entre 3 réglages relatifs aux cookies. Le réglage standard nous permet de vous offrir un site web fonctionnant de manière optimale.",
  "CookieMessage.settings.standard.title":
    "Standard (option la plus fréquemment choisie):",
  "CookieMessage.settings.standard.body":
    "cookies relatifs aux ouvertures de session, commandes, analyses, offres personnalisées, réseaux sociaux et cookies de tiers basés en Europe et hors Europe.",
  "CookieMessage.settings.restricted.title": "Limité :",
  "CookieMessage.settings.restricted.body":
    "cookies relatifs aux ouvertures de session, commandes, analyses et offres personnalisées.",
  "CookieMessage.settings.highly_restricted.title": "Très limité:",
  "CookieMessage.settings.highly_restricted.body":
    "vous acceptez le moins de cookies possible. Uniquement pour les ouvertures de session, les commandes et pour profiter d’un site web fonctionnant assez bien.",
  "CookieMessage.settings.options.title": "Ce que nous faisons:",
  "CookieMessage.settings.option.1":
    "Nous utilisons des cookies afin de garantir le bon fonctionnement correct de ce site web",
  "CookieMessage.settings.option.2":
    "Nous réalisons des études sur les utilisateurs",
  "CookieMessage.settings.option.3":
    "Nous tenons des statistiques personnelles",
  "CookieMessage.settings.option.4":
    "Nous vous transmettons des informations en fonction de vos intérêts",
  "CookieMessage.settings.option.5":
    "Nous utilisons des informations à des fins publicitaires",
  "CookieMessage.settings.option.6": "Nous tenons des statistiques anonymes",
  "CookieMessage.settings.option.7": "Nous partageons vos données personnelles",
  "CookieMessage.settings.title": "Configuration des cookies",
  "CookiePage.url": "politique-de-confidentialite-et-cookies",
};
